import { useAtomValue, useSetAtom } from "jotai";
import { useCallback, useEffect } from "react";

import {
  contractEditorAtom,
  loadContractEditorAtom,
  saveContractAtom,
} from "../stores/editor";

export type UseContractEditorOptions = {
  projectId: number;
  contractId?: number | null;
  onSaved?: (contractId: number) => void;
  onCancel?: () => void;
};

export type UseContractEditor = {
  loading: boolean;
  saving: boolean;
  error: string | null;
  conflict: boolean;
  save: () => Promise<void>;
  cancel: () => void;
};

export function useContractEditor({
  projectId,
  contractId = null,
  onSaved,
  onCancel,
}: UseContractEditorOptions): UseContractEditor {
  const { loading, saving, error, conflict } = useAtomValue(contractEditorAtom);

  const load = useSetAtom(loadContractEditorAtom);
  const saveContract = useSetAtom(saveContractAtom);

  useEffect(() => {
    void load(projectId, contractId);
  }, [load, projectId, contractId]);

  const save = useCallback(async () => {
    const savedId = await saveContract();

    if (null !== savedId) {
      onSaved?.(savedId);
    }
  }, [saveContract, onSaved]);

  const cancel = useCallback(() => onCancel?.(), [onCancel]);

  return { loading, saving, error, conflict, save, cancel };
}
